"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Strips the version segment from an iglu URI so contexts targeting the
// same entity at different versions compare equal, e.g.
//   iglu:com.angi.entities/component_attributes/jsonschema/6-0-3
//     → iglu:com.angi.entities/component_attributes
const stripSchemaVersion = (schemaUri) => schemaUri.split('/jsonschema/')[0];
exports.default = stripSchemaVersion;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RyaXBTY2hlbWFWZXJzaW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL3V0aWxzL2R5bmFtaWNDb250ZXh0L2NvbXBvbmVudHMvc3RyaXBTY2hlbWFWZXJzaW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsd0VBQXdFO0FBQ3hFLHdEQUF3RDtBQUN4RCxpRUFBaUU7QUFDakUsb0RBQW9EO0FBQ3BELE1BQU0sa0JBQWtCLEdBQUcsQ0FBQyxTQUFpQixFQUFVLEVBQUUsQ0FBQyxTQUFTLENBQUMsS0FBSyxDQUFDLGNBQWMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO0FBRTdGLGtCQUFlLGtCQUFrQixDQUFDIn0=


// WEBPACK FOOTER //
// ../../../../../src/utils/dynamicContext/components/stripSchemaVersion.ts